<template>
  <section class="page-title-wrap position-relative text-center over-bg" :class="{ active: active }">

    <svg xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 ' + winW + ' ' + (winH + 106)" :height="(winH + 106) + 'px'">
      <defs>
        <polygon id="page7-grad-large"
                 :points="isSmall ? '0 0 ' + winW + ' 0 ' + winW + ' ' + (winH + 104) + ' 0 ' + (winH + 24) : '0 0 ' + winW + ' 0 ' + winW + ' ' + (winH - 15) + ' 0 ' + (winH - 104)"/>
        <linearGradient id="page7-a" x1="12.794%" x2="31.221%" y1="98.029%" y2="71.65%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page7-b" x1="45.744%" x2="45.744%" y1="100%" y2="9.216%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page7-c" x1="50%" x2="50%" y1="26.741%" y2="100%">
          <stop offset="0%" :stop-color="accent"/>
          <stop offset="100%" :stop-color="liteAccent" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="page7-d" x1="50%" x2="50%" y1="-7.331%" y2="75.546%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="100%" :stop-color="accent" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="page7-e" x1="50%" x2="50%" y1="69.274%" y2="0%">
          <stop offset="0%" :stop-color="mainColor" stop-opacity="0"/>
          <stop offset="100%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page7-f" x1="0%" x2="100%" y1="0%" y2="0%">
          <stop offset="0%" :stop-color="mainColor"/>
          <stop offset="30%" :stop-color="accent"/>
        </linearGradient>
        <linearGradient id="page7-g" x1="50%" y1="26.7412895%" x2="50%" y2="100%">
          <stop offset="0%" :stop-color="accent"/>
          <stop stop-opacity="0" offset="100%" :stop-color="mainColor"/>
        </linearGradient>
      </defs>

      <polygon
        :fill="isSmall ? 'url(#page7-a)' : 'url(#page7-f)'"
        :points="isSmall ? winW + ' 0 ' + winW + ' ' + (winH + 20) + ' 0 ' + (winH + 100) + ' 0 0' : winW + ' 0 ' + winW + ' ' + (winH - 104) + ' 0 ' + (winH - 15) + ' 0 0' "
      />

      <mask id="page7-grad-large-mask" fill="white">
        <use xlink:href="#page7-grad-large"/>
      </mask>
      <use fill="url(#page7-b)" xlink:href="#page7-grad-large"></use>

      <ellipse
        v-if="!isSmall"
        fill-opacity="0.7"
        fill="url(#page7-g)"
        mask="url(#page7-grad-large-mask)"
        cx="82.5663028"
        :cy="winH * 0.886"
        rx="93.5621533"
        ry="91.0782024"
        style="opacity: 0"
        ref="clippedCirc"
      />

      <ellipse
        :cx="isSmall ? ((winW / 2) - 187.5) + 186.5 : winW / 2"
        :cy="isSmall ? ((winH / 2) - 333.5) + 411 : winH / 2"
        fill="url(#page7-c)"
        fill-opacity=".7"
        :rx="isSmall ? 56.5 : 120"
        :ry="isSmall ? 55 : 120"
        :data-transform="isSmall ? 'rotate(-30 ' + (((winW / 2) - 187.5) + 186.5) + ' ' + (((winH / 2) - 333.5) + 411) + ')' : 'rotate(0 0 0)'"
        style="opacity: 0"
        ref="mainCirc"
      />

      <g v-if="isSmall" data-transform="rotate(40.1 -111.621 134.798)" transform="translate(-150,0) rotate(40.1 -111.621 134.798)" style="opacity: 0" ref="box">
        <rect width="74.682" height="228.865" x="20.083" y=".966" fill="url(#page7-d)"/>
        <polygon fill="url(#page7-e)" points=".083 42.378 19.796 .966 19.796 229.831 .083 271.243"/>
      </g>
      <g v-else data-transform="rotate(40.1 -180.1 170.1)" transform="rotate(40.1 -180.1 170.1)" style="opacity: 0" ref="box">
        <rect fill="url(#page7-d)" x="30.2098455" y="1.13686838e-13" width="114.453324" height="351.634295"></rect>
        <polygon fill="url(#page7-e)"
                 points="-2.27373675e-13 63.6257908 30.2098455 1.13686838e-13 30.2098455 351.634295 -2.27373675e-13 415.260085"></polygon>
      </g>

      <g v-if="!isSmall" ref="box2"
        style="opacity: 0"
        :data-transform="'scale(-1, 1) rotate(25)'">
        <rect fill="url(#page7-d)" x="39.618143" y="1.13686838e-13" width="150.097695" height="459.976807"></rect>
        <polygon fill="url(#page7-e)"
                 points="-2.27373675 83.2296182 39.618143 1.13686838 39.618143 459.976807 -2.27373675 543.206425"></polygon>
      </g>

      <ellipse
        :cx="isSmall ? ((winW / 2) - 187.5) + 361.5 : winW * 0.93"
        :cy="isSmall ? ((winH / 2) - 333.5) + 560.5 : winH * 0.12"
        fill="url(#page7-c)"
        fill-opacity=".7"
        :rx="isSmall ? 25.5 : 65"
        :ry="isSmall ? 24.5 : 65"
        :data-transform=" isSmall ? 'rotate(135 ' + (((winW / 2) - 187.5) + 361.5) + ' ' + (((winH / 2) - 333.5) + 560.5) + ')' : 'rotate(40 ' + (winW * 0.93) + ' ' + (winH * 0.12) + ')'"
        style="opacity: 0"
        ref="sideCirc"
      />
    </svg>

    <div class="position-absolute d-flex flex-column align-items-stretch w-75 title-text" :style="txtStyles">
      <header class="d-flex flex-column justify-content-end align-items-center pb-5 header-wrap">

        <h1
          class="mb-0 heading"
          v-html="head"
          ref="head"
          :style="{ letterSpacing: headSpace + 'em', paddingLeft: headSpace + 'em' }"
        ></h1>
        <span class="subhead" v-html="subhead" ref="sub"></span>

      </header>

      <div class="footer-wrap d-flex flex-column justify-content-center align-items-center">

        <h2
          class="mb-4 keyword"
          v-html="kw"
          ref="kw"
          :style="{ letterSpacing: kwSpace + 'em', paddingLeft: kwSpace + 'em' }"
        ></h2>

        <div class="numeral-wrap position-relative">
          <svg class="orb-vect" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 45">
            <defs>
              <linearGradient id="page7_orb" x1="50%" x2="50%" y1="100%" y2="0%"
                              :gradientTransform="'rotate(' + orbDeg + ' 0.5 0.5)'">
                <stop offset="0%" :stop-color="gradMidPt"/>
                <stop offset="100%" :stop-color="mainColor"/>
              </linearGradient>

              <linearGradient id="page7_line" x1="-25.494%" x2="100%" y1="50%" y2="50%">
                <stop offset="0%" :stop-color="accent"/>
                <stop offset="97.541%" :stop-color="mainColor"/>
              </linearGradient>
            </defs>

            <ellipse style="opacity: 0" cx="30.5" cy="23" fill="url(#page7_orb)" rx="21.5" ry="21"
                     transform="rotate(135 30.5 23)" ref="orb"/>
            <rect style="opacity: 0" width="60" height="3" y="21" fill="url(#page7_line)" ref="ring"/>
          </svg>

          <div class="dashes d-flex justify-content-center overflow-hidden position-absolute" :style="[ isSmall && isSafari ? { height: '115px' } : { height: '150px' } ]">
            <div class="inner position-absolute h-100" :style="{ borderLeft: '1px dashed ' + mainColor }"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="position-fixed w-100 h-100 pointer-events-none fade-to-white" style="opacity: 1" ref="fade"></div>

  </section>
</template>

<script>
  import { TimelineMax, Back, Power3 } from 'gsap'
  import { lighten, shuffleArr, gradPtColor } from '@/lib/funcs'
  import TitleMixin from '@/components/report/mixins/TitleMixin'

  export default {
    name: 'Title7',
    mixins: [ TitleMixin ],
    data () { return { tl: new TimelineMax(), orbDeg: 0 } },
    computed: {
      liteAccent () { return lighten( this.accent, 0.69 ) },

      gradMidPt () { return gradPtColor( ...this.colors, 0.5 ) }
    },
    methods: {
      setTweens () {
        if ( !this.isSmall ) {
          this.tl.set( this.$refs.box2, {
            attr: {
              transform: `translate(${this.winW * 0.95 + this.$refs.box2.getBBox().width}, ${this.winH * 0.9 - this.$refs.box2.getBBox().height / 2}) ${this.$refs.box2.getAttribute( 'data-transform' )}`
            }
          } )
          this.tl.set( this.$refs.clippedCirc, { xPercent: -100 } )
        }

        this.tl.set( [ this.headSpans, this.kwSpans, this.$refs.sub ], { opacity: 0 } )
          .set( this.$refs.mainCirc, { scale: 0, transformOrigin: '50% 50%' } )
          .set( this.$refs.sideCirc, { xPercent: 100 } )
          .set( this.$refs.box, { attr: { transform: `translate(-${this.$refs.box.getBBox().width}, 0) ${this.$refs.box.getAttribute( 'data-transform' )}` } } )
          .set( this.$refs.ring, { scaleX: 0, opacity: 1 } )
          .set( this.$refs.orb, { scale: 0, transformOrigin: '50% 50%', opacity: 1 } )
          .set( this.$refs.sub, { yPercent: 100 } )
      },
      tweenIn () {
        let headSpans = shuffleArr( [ ...this.headSpans ] )
        let kwSpans = shuffleArr( [ ...this.kwSpans ] )
        let circEls = [ this.$refs.sideCirc ]
        if ( !this.isSmall ) {
          circEls.push( this.$refs.clippedCirc )
        }

        this.tl.to( this.$refs.mainCirc, this.time, {
          opacity: 1,
          scale: 1,
          ease: Back.easeOut.config( 1.7 )
        }, 'in' )
          .to( this.$refs.fade, this.time * 0.75, { opacity: 0 }, 'in' )
          .to( this, this.time, { headSpace: 0.1 }, 'in' )
          .staggerTo( headSpans, this.time, { opacity: 1 }, this.stagger, 'in' )
          .to( this.$refs.sub, this.time, { opacity: 1, yPercent: 0 }, 'in' )
          .to( this.$refs.box, this.time * 3, {
            opacity: 1,
            ease: Power3.easeOut,
            attr: {
              transform: `translate(0,0) ${this.$refs.box.getAttribute( 'data-transform' )}`
            }
          }, 'in+=' + this.stagger )

        if ( !this.isSmall ) {
          this.tl.to( this.$refs.box2, this.time * 3, {
            opacity: 1,
            ease: Power3.easeOut,
            attr: {
              transform: `translate(${this.winW * 0.95}, ${this.winH * 0.9 - this.$refs.box2.getBBox().height / 2}) ${this.$refs.box2.getAttribute( 'data-transform' )}`
            }
          }, 'in+=' + this.stagger )
        }

        this.tl.to( circEls, this.time * 3, {
          opacity: 1,
          xPercent: 0,
          ease: Power3.easeOut
        }, 'in+=' + (this.stagger * 2) )
        .to( this, this.time, { kwSpace: 0.2666 }, 'in+=' + (this.stagger * 2) )
        .staggerTo( kwSpans, this.time, { opacity: 1 }, this.stagger, 'in+=' + (this.stagger * 2) )
        .to( this.$refs.ring, this.time, { scaleX: 1, ease: Power3.easeOut }, 'in+=' + (this.stagger * 2) )
        .to( this.$refs.orb, this.time, { scale: 1, ease: Power3.easeOut }, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
        .call( () => this.$emit( 'tween-done' ), [], this, 'in+=' + (this.stagger * 2 + (this.time / 2)) )
        .to( this, this.time * 10, { orbDeg: 360 }, 'in+=' + (this.stagger * 2) )
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .fade-to-white {
    top        : 0;
    left       : 0;
    background : $white;
    z-index    : 15;
    transform  : none !important;
  }

  @include screen-md-lg-xl {

    .page-title-wrap .footer-wrap {
      height : 50vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/titleVects/Title7.vue